import { Button, HStack, Icon, Text, VStack } from "@chakra-ui/react";
import dayjs from "dayjs";
import { FaVideo } from "react-icons/fa6";
import { RiCalendarTodoFill, RiTimerLine } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { openAddVoucherModel } from "../../../modules/admin-modules/models/Actions";
import { moreVideoViewsRequest } from "../../../modules/students-modules/videos/Actions";

const VideoCourse = ({ video, setSelectedData }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { chapter } = useSelector((state) => state.studentChapters);

  const date1 = dayjs(video?.expiry_date);
  const diff = date1.diff(new Date(), "day");

  const getLockMessage = () => {
    if (video?.views_count && video?.views_count?.views_count == 3) {
      return "Contact the technical support";
    }
    
    if (video?.views_count && video?.views_count?.views_count == 4) {
      return "You have exceeded the allowed watch duration. You can request a voucher and contact your assistant.";
    }
    
    if (video?.suspended == 1 && video?.user_video_suspended != 0) {
      const hasExams = video?.exams && video?.exams?.length > 0;
      const examName = hasExams ? video?.exams[0]?.name : null;
      const homeworkName = video?.homework?.name;
      
      if (video?.related_to_homework == 1 && hasExams) {
        return `Video locked please submit HW: ${homeworkName} or solve the exam: ${examName}`;
      }
      
      if (video?.related_to_homework == 1 && !hasExams) {
        return `Video locked please submit HW: ${homeworkName}`;
      }
      
      if (video?.related_to_homework == 0 && hasExams) {
        return `Video locked please solve the exam: ${examName}`;
      }
      
      return "Video locked request voucher and contact the assistant";
    }
    
    return null;
  };

  const lockMessage = getLockMessage();
  return (
    <VStack
      w="100%"
      fontSize="14px"
      alignItems="flex-start"
      onClick={() => {
        if (
          video?.max_allowed_views < video?.views_count?.views_count ||
          (video?.suspended === 0 || video?.user_video_suspended === 0)
        ) {
          navigate(
            `/video/${video?.id}?chapter_name=${chapter?.name}&chapter_id=${chapter?.id}`
          );
        }
      }}
    >
      <VStack
        w="100%"
        fontSize="14px"
        alignItems="flex-start"
        border="1px solid #eee"
        p={4}
        borderRadius={5}
        cursor="pointer"
        shadow="lg"
      >
        <HStack w="100%">
          <FaVideo size={18} />
          {/* title */}
          <Text fontSize="18px" fontWeight="500" textTransform="capitalize">
            {video?.title || video?.name}
          </Text>
        </HStack>
        <HStack spacing="8px">
          <Icon as={RiCalendarTodoFill} size={18} />
          <Text>{dayjs(video?.created_at).format("D , MMM ,YYYY")}</Text>
        </HStack>
        {diff && (
          <HStack>
            <Icon as={RiTimerLine} size={18} />
            <Text>{diff > 0 ? diff : 0} Days remaining</Text>
          </HStack>
        )}
                 {(video?.max_allowed_views <= video?.views_count?.views_count ||
           (video?.suspended === 1 && video?.user_video_suspended !== 0)) && (
           <>
             {lockMessage && (
               <Text textAlign="center" p={4} fontSize="20px">
                 {lockMessage}
               </Text>
             )}
             <HStack alignItems="center" gap={1} alignSelf="end">
               <Button
                 bg="main_1"
                 color="white"
                 onClick={(e) => {
                   console.log(video);
                   e.stopPropagation();
                   let formData = new FormData();
                   formData.append("video_id", video?.id);
                   dispatch(moreVideoViewsRequest(formData));
                 }}
               >
                 Request Voucher
               </Button>
               <Button
                 mt="0 !important"
                 border="1px solid"
                 color="main_1"
                 bg="main_1_light"
                 onClick={(e) => {
                   setSelectedData(video);
                   dispatch(openAddVoucherModel());
                 }}
               >
                 Add Voucher Code
               </Button>
             </HStack>
           </>
         )}
      </VStack>
    </VStack>
  );
};

export default VideoCourse;
